// Curated palette: avoid red/yellow tones to prevent confusion with status colors.
// Each entry is [bg, text].
const PALETTE = [
    ['bg-emerald-100', 'text-emerald-800'],
    ['bg-blue-100',    'text-blue-800'],
    ['bg-purple-100',  'text-purple-800'],
    ['bg-pink-100',    'text-pink-800'],
    ['bg-indigo-100',  'text-indigo-800'],
    ['bg-teal-100',    'text-teal-800'],
    ['bg-cyan-100',    'text-cyan-800'],
    ['bg-fuchsia-100', 'text-fuchsia-800'],
];

function hashString(str) {
    let h = 0;
    for (let i = 0; i < str.length; i++) h = (h * 31 + str.charCodeAt(i)) | 0;
    return Math.abs(h);
}

function initialsOf(name) {
    if (!name) return '?';
    const parts = name.trim().split(/\s+/);
    if (parts.length === 1) return parts[0][0]?.toUpperCase() ?? '?';
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

const SIZES = {
    sm: 'w-8 h-8 text-xs',
    md: 'w-10 h-10 text-sm',
    lg: 'w-14 h-14 text-base',
};

export function Avatar({ user, size = 'md' }) {
    const sizeCls = SIZES[size] ?? SIZES.md;
    if (user?.avatar_url) {
        return (
            <img
                src={user.avatar_url}
                alt={user.name}
                className={`${sizeCls} rounded-full object-cover`}
            />
        );
    }
    const [bg, fg] = PALETTE[hashString(user?.name || '?') % PALETTE.length];
    return (
        <div
            className={`${sizeCls} ${bg} ${fg} rounded-full flex items-center justify-center font-medium`}
            aria-label={user?.name}
        >
            {initialsOf(user?.name)}
        </div>
    );
}
